import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields, TableComp } from 'sz-react-utils'
import Quali from '../../../../components/qualification'
import MasterDocUtils from '../../../../components/_utils/masterDocUtil'
import { Button, Card, Col, Form, notification, Row, Table, Tabs, Upload, Icon, InputNumber, Tag, Tooltip, Input, Select, Modal } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../../../request'
import { connect } from 'react-redux'
import fs, { writeFile } from 'fs'
import styles from './styles.less'
import style from '../../course/add/styles.less'
import PDFFileView from '../../../../components/DocumentViews/PDFFileView'

const TabPane = Tabs.TabPane
// following variables needed for update country
let docLoaded = null
let universityId = null

const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

const Option = Select.Option

const typeofDegree = {
    Diploma: [
        { key: 'Diploma Of Engineering', value: 'Diploma Of Engineering' },
        { key: 'Diploma Of Management', value: 'Diploma Of Management' }
    ],
    'Bachelor Degree': [
        { key: 'Bachelor of Agriculture', value: 'Bachelor of Agriculture' },
        { key: 'Bachelor of Arts', value: 'Bachelor of Arts' },
        {
            key: 'Bachelor of Ayurvedic Medicine & Surgery - BAMS',
            value: 'Bachelor of Ayurvedic Medicine & Surgery - BAMS'
        },
        {
            key: 'Bachelor of Business Administration',
            value: 'Bachelor of Business Administration'
        },
        { key: 'Bachelor of Commerce', value: 'Bachelor of Commerce' },
        {
            key: 'Bachelor of Computer Applications',
            value: 'Bachelor of Computer Applications'
        },
        {
            key: 'Bachelor of Computer Science',
            value: 'Bachelor of Computer Science'
        },
        {
            key: 'Bachelor of Dental Surgery - BDS',
            value: 'Bachelor of Dental Surgery - BDS'
        },

        { key: 'Bachelor of Design', value: 'Bachelor of Design' },
        { key: 'Bachelor of Education', value: 'Bachelor of Education' },
        { key: 'Bachelor of Engineering', value: 'Bachelor of Engineering' },
        { key: 'Bachelor of Fine Arts', value: 'Bachelor of Fine Arts' },
        { key: 'Bachelor of Home Science', value: 'Bachelor of Home Science' },

        {
            key: 'Bachelor of Homeopathic Medicine and Surgery - BHMS',
            value: 'Bachelor of Homeopathic Medicine and Surgery - BHMS'
        },
        { key: 'Bachelor of Laws', value: 'Bachelor of Laws' },
        {
            key: 'Bachelor of Mass Communications',
            value: 'Bachelor of Mass Communications'
        },
        {
            key: 'Bachelor of Medicine and Bachelor of Surgery (MBBS)',
            value: 'Bachelor of Medicine and Bachelor of Surgery (MBBS)'
        },
        { key: 'Bachelor of Nursing', value: 'Bachelor of Nursing' },
        { key: 'Bachelor of Pharmacy', value: 'Bachelor of Pharmacy' },
        { key: 'Bachelor of Physiotherapy', value: 'Bachelor of Physiotherapy' },
        { key: 'Bachelor of Science', value: 'Bachelor of Science' },
        { key: 'Bachelor of Social Work', value: 'Bachelor of Social Work' },
        { key: 'Bachelor of Technology', value: 'Bachelor of Technology' },
        {
            key: 'Bachelor of Veterinary Science & Animal Husbandry',
            value: 'Bachelor of Veterinary Science & Animal Husbandry'
        },
        { key: 'Doctor of Medicine', value: 'Doctor of Medicine' },
        {
            key: 'Doctor of Medicine in Homoeopathy',
            value: 'Doctor of Medicine in Homoeopathy'
        },
        { key: 'Doctor of Pharmacy', value: 'Doctor of Pharmacy' },
        { key: 'Doctorate of Medicine', value: 'Doctorate of Medicine' },
        {
            key: 'General Nursing & Midwifery (GNM)',
            value: 'General Nursing & Midwifery (GNM)'
        },
        { key: 'Bachelor of Journalism', value: 'Bachelor of Journalism' },
        { key: 'ITI', value: 'ITI' },
        { key: 'Other', value: 'Other' }
    ],
    'Post Graduation': [
        { key: 'Master of Agriculture', value: 'Master of Agriculture' },
        { key: 'Master of Arts', value: 'Master of Arts' },
        {
            key: 'Master of Ayurvedic Medicine & Surgery - BAMS',
            value: 'Master of Ayurvedic Medicine & Surgery - BAMS'
        }
    ]
}

@Form.create()
class AddUniversity extends React.Component {

    handleSubmit = e => {
        const { dispatch, form } = this.props
        const { statesData, countriesData, citiesData, institutionalIncentive } = this.state
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values.enrollmentList = this.state.enrollmentList
                values.subCampusList = this.state.subCampusList
                values.ieltsRequirements = this.state.ieltsRequirements
                values.qualification = this.state.list
                values.ieltsScoreAcceptable = this.state.ieltsScoreAcceptable;
                values.bachelorDegreeAcceptable = this.state.bachelorDegreeAcceptable;
                values.invoiceDetails = this.state.applicantsList;
                if (values && values.universityCountryId && countriesData) {

                    let found = _.find(countriesData, (item) => {
                        return item._id == values.universityCountryId
                    })
                    if (found) {
                        values.universityCountryName = found.display
                    }
                }
                if (values && values.universityStateId && statesData) {
                    let found = _.find(statesData, (item) => {
                        return item._id == values.universityStateId
                    })
                    if (found) {
                        values.universityStateName = found.display
                    }
                }
                if (values && values.universityCityId && citiesData) {

                    let found = _.find(citiesData, (item) => {

                        return item.id == values.universityCityId
                    })

                    if (found) {
                        values.universityCityName = found.display
                    }
                }

                if (institutionalIncentive) {
                    values.institutionalIncentive = institutionalIncentive;
                }


                if (universityId) {
                    values = { ...values, _id: universityId }

                    dispatch(showLoader())
                    let x = await Request.updateUniversity(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.message
                        })
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.message
                        })
                    }
                } else {
                    dispatch(showLoader())


                    let x = await Request.addUniversity(values)

                    dispatch(hideLoader())

                    if (!x.error) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })

                        form.resetFields()
                        this.setState({
                            enrollmentList: [],
                            subCampusList: []
                        })

                        // dispatch('/all-countries')
                    } else {
                        notification.error({
                            message: 'Error Saving',
                            description: x.msg
                        })
                    }
                }
            }
        })
    }

    callback = key => {
        if (key == 7) {
            this.setState({ showSave: 0 })
        } else {
            this.setState({ showSave: 1 })
        }

        let inputTypes = this.state.inputTypes

        if (universityId && inputTypes[key - 1] && !inputTypes[key - 1].opened) {
            inputTypes[key - 1].opened = true
            let tempObj = {}
            _.each(inputTypes[key - 1].fields, (v, k) => {
                if (docLoaded) {
                    tempObj[v.key] = docLoaded[v.key]
                }
            })
            setTimeout(() => {
                this.props.form.setFieldsValue(tempObj)
            }, 10)
        }
    }

    addSubCampus = () => {
        let state
        let city
        let channelPartner
        if (!this.state.subCampusName) {
            notification.error({
                message: 'Warning',
                description: 'Enter Campus Name'
            })
            return
        }
        if (this.state.subCampusPartnership == "Channel Partner" && !this.state.subCampusChannelPartner) {
            notification.error({
                message: 'Warning',
                description: 'Select Channel Partner'
            })
            return
        }
        state = this.state.statesData.find(x => x._id == this.state.subCampusState);
        city = this.state.citiesData.find(x => x._id == this.state.subCampusCity);
        channelPartner = this.state.subCampusChannelPartner && this.state.subCampusChannelPartner != null ?
            this.state.channelPartners.find(x => x._id == this.state.subCampusChannelPartner)
            : null
        this.setState({
            subCampusList: [
                ...this.state.subCampusList,
                ...[
                    {
                        campusName: this.state.subCampusName,
                        campusPartnership: this.state.subCampusPartnership,
                        channelPartner: this.state.subCampusChannelPartner && this.state.subCampusChannelPartner != null ?
                            { id: channelPartner._id, name: channelPartner.channelPartnerName }
                            : null,
                        state: { id: state._id, name: state.display },
                        city: { id: city._id, name: city.display },
                        status: this.state.subCampusStatus
                    }
                ]
            ],
            subCampusName: null,
            subCampusChannelPartner: null,
            subCampusPartnership: null,
            subCampusState: null,
            subCampusCity: null,
            subCampusStatus: null
        })
        state = null
        city = null
        channelPartner = null
    }

    // handleReferenceSubmit = () => {
    //     let { form } = this.props;
    //     let billingDetailValues = form.getFieldsValue([
    //         'type',
    //         'invoiceToName',
    //         'invoiceAddress',
    //         'kindAttention',
    //         'invoiceToEmail',
    //         'invoiceToPhoneCode',
    //         'invoiceToPhone',
    //         'invoiceToCategory',
    //         'default'
    //     ]);

    //     let requiredFields = [
    //         'type',
    //         'invoiceToName',
    //         'invoiceAddress',
    //         'kindAttention',
    //         'invoiceToEmail',
    //         'invoiceToPhoneCode',
    //         'invoiceToPhone',
    //         'invoiceToCategory'
    //     ];

    //     let missingField = requiredFields.find(field => {
    //         const value = billingDetailValues[field];
    //         return value === undefined || value === null || value === '';
    //     });

    //     if (missingField) {
    //         notification.error({
    //             message: `Please enter ${missingField}`
    //         });
    //         return;
    //     }
    //     if (!billingDetailValues.default) {
    //         billingDetailValues.default = false;
    //     }
    //     let applicantsList = this.state.applicantsList
    //     applicantsList.push(billingDetailValues)
    //     this.setState({ applicantsList, showApplicantModal: false }, () => {
    //         this.props.form.setFieldsValue({
    //             type: null,
    //             invoiceToName: null,
    //             invoiceAddress: null,
    //             kindAttention: null,
    //             invoiceToEmail: null,
    //             invoiceToPhoneCode: null,
    //             invoiceToPhone: null,
    //             invoiceToCategory: null
    //         })
    //     });

    // }

    handleReferenceSubmit = () => {

        let { form } = this.props;

        let billingDetailValues = form.getFieldsValue([
            'type',
            'invoiceToName',
            'invoiceAddress',
            'kindAttention',
            'invoiceToEmail',
            'invoiceToPhoneCode',
            'invoiceToPhone',
            'invoiceToCategory',
            'default'
        ]);

        let requiredFields = [
            'type',
            'invoiceToName',
            'invoiceAddress',
            'kindAttention',
            'invoiceToEmail',
            'invoiceToPhoneCode',
            'invoiceToPhone',
            'invoiceToCategory'
        ];

        let missingField = requiredFields.find(field => {
            const value = billingDetailValues[field];
            return value === undefined || value === null || value === '';
        });

        if (missingField) {
            notification.error({
                message: `Please enter ${missingField}`
            });
            return;
        }

        if (!billingDetailValues.default) {
            billingDetailValues.default = false;
        }

        let applicantsList = [...this.state.applicantsList];

        if (this.state.editIndex !== null) {

            // UPDATE EXISTING
            applicantsList[this.state.editIndex] = billingDetailValues;

        } else {

            // ADD NEW
            applicantsList.push(billingDetailValues);
        }

        this.setState({
            applicantsList,
            showApplicantModal: false,
            editIndex: null
        }, () => {

            this.props.form.setFieldsValue({
                type: null,
                invoiceToName: null,
                invoiceAddress: null,
                kindAttention: null,
                invoiceToEmail: null,
                invoiceToPhoneCode: null,
                invoiceToPhone: null,
                invoiceToCategory: null,
                default: false
            });
        });
    };

    removeCommissionRow = (index) => {
        this.setState((prevState) => {
            const updatedCommissions = [...prevState.applicantsList]; // copy array
            updatedCommissions.splice(index, 1); // remove item at index
            return { applicantsList: updatedCommissions };
        });
    };
    addEnrollment = () => {
        if (!this.state.ei) {
            notification.success({
                message: 'Warning',
                description: 'Enter Institue'
            })
            return
        }
        this.setState({
            exportLoading: false,
            importLoading: false,
            enrollmentList: [
                ...this.state.enrollmentList,
                ...[
                    {
                        filename: this.state.ei,
                        desc: this.state.ec,
                        branch: this.state.ew
                    }
                ]
            ],
            ei: null,
            ec: null,
            ew: null
        })

        this.ei.value = null
        this.ec.value = null
        this.ew.value = null
    }
    setFormValues = async universityId => {
        try {
            let { doc } = await Request.getUniversity(universityId)
            if (doc) {
                docLoaded = doc
                this.setState({ paymentUpload: doc.paymentUpload, paymentUploadCommissionPage: doc.paymentUploadCommissionPage, applicantsList: doc.invoiceDetails ? doc.invoiceDetails : [] });
                doc.agreementSigningDate = moment(doc.agreementSigningDate)
                doc.enrollmentExpiry = moment(doc.enrollmentExpiry)
                doc.enrollmentRenewal = moment(doc.enrollmentRenewal)
                doc.contactLogo = _.map(doc.contactLogo, (item) => {
                    let ind = item.url.indexOf('http')
                    item.url = ind >= 0 ? `${item.url}` : `${LAPI_URL}${item.url}`
                    return item
                })
                if (doc.differentApplicationFee && doc.differentApplicationFee === true) {
                    let inputTypes = this.state.inputTypes
                    inputTypes[2]['fields'][4].hidden = !doc.differentApplicationFee
                    inputTypes[2]['fields'][5].hidden = !doc.differentApplicationFee
                    inputTypes[2]['fields'][6].hidden = doc.differentApplicationFee
                    this.setState({ inputTypes })
                }
                if (doc && doc.isAgreementExpire) {
                    let inputTypes = this.state.inputTypes
                    inputTypes[4]['fields'][2].hidden = doc.isAgreementExpire ? false : true
                    inputTypes[4]['fields'][3].hidden = doc.isAgreementExpire ? false : true
                    inputTypes[4]['fields'][2].required = doc.isAgreementExpire ? true : false
                    inputTypes[4]['fields'][3].required = doc.isAgreementExpire ? true : false
                    this.setState({ inputTypes })
                }
                if (doc.ieltsRequirements) {
                    this.setState({ ieltsRequirements: doc.ieltsRequirements })
                }
                if (doc.qualification) {
                    this.setState({ list: doc.qualification })
                }
                if (doc && doc.ieltsScoreAcceptable) {
                    this.setState(
                        { ieltsScoreAcceptable: docLoaded.ieltsScoreAcceptable })
                }
                if (doc.bachelorDegreeAcceptable) {
                    this.setState(
                        { bachelorDegreeAcceptable: docLoaded.bachelorDegreeAcceptable })
                }
                await this.loadStates(doc.universityCountryId)
                await this.loadCities(doc.universityStateId)
                let tempCourse = [{ display: "---Show All---", id: "" }];
                let tempObj = {}
                let inputTypes = this.state.inputTypes

                _.each(inputTypes, (val, kk) => {
                    if (kk == '0') {
                        _.each(inputTypes[0].fields, (v, k) => {
                            if (docLoaded) {
                                tempObj[v.key] = docLoaded[v.key]
                            }
                            if (v.key == "ieltsScoreAcceptableUniversityBasis") {
                                v.defaultChecked = docLoaded[v.key];
                            } if (v.key == "bachelorDegreeRequirementUniversityBasis") {
                                v.defaultChecked = docLoaded[v.key];
                            } if (v.key == "moi") {
                                v.defaultChecked = docLoaded[v.key];
                            } if (v.key == "preferredPartner") {
                                v.defaultChecked = docLoaded[v.key];
                            }
                        })
                    }
                })
                doc.course = doc.course && doc.course.reduce((ev, vl) => {
                    vl.display = vl.courseName;
                    vl.id = vl._id;
                    tempCourse.push(vl)
                    return tempCourse
                }, [])
                this.setState({ courses: doc.course })
                this.setState({
                    enrollmentList: docLoaded.enrollmentList
                        ? docLoaded.enrollmentList
                        : []
                })
                this.setState({
                    subCampusList: docLoaded.subCampusList
                        ? docLoaded.subCampusList
                        : []
                })
                this.setState({ institutionalIncentive: doc.institutionalIncentive })
                tempObj.restrictedLocalUniversityId = doc.restrictedLocalUniversityId;
                tempObj.restrictedLocationId = doc.restrictedLocationId;
                tempObj.consortiumId = doc.consortiumId;
                tempObj.universityCountryId = doc.universityCountryId
                this.props.form.setFieldsValue(tempObj)
            }
        } catch (e) {
            console.log(e)
        }
    }
    loadCountries = () => {
        Request.getCountriesWithoutAuth({
            results: 200,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId
        })
            .then(resp => {
                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.countryName })
                    if (vv.countryPhoneCode) {
                        phoneCodes.push(vv.countryPhoneCode);
                    }
                    return temp
                }, [])
                this.setState({ phoneCodes })

                let inputTypes = this.state.inputTypes

                inputTypes[0]['fields'][0].options = resp.data;
                inputTypes[1]['fields'][0].options = resp.data;
                inputTypes[2]['fields'][9].options = phoneCodes;
                inputTypes[2]['fields'][13].options = phoneCodes;
                inputTypes[2]['fields'][17].options = phoneCodes;
                inputTypes[2]['fields'][21].options = phoneCodes;
                inputTypes[2]['fields'][29].options = phoneCodes;
                this.setState({ inputTypes: inputTypes, countriesData: resp.data });
                this.refreshFxn()
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadStates = async id => {
        Request.loadStates(id)
            .then(daa => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        id: val._id,
                        _id: val._id,
                        display: val.stateName
                    })
                    return total
                }, [])

                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][1].options = daa.result
                inputTypes[1]['fields'][1].options = daa.result
                this.setState({ inputTypes: inputTypes, statesData: daa.result })
                this.refreshFxn()
            })
            .catch(err => {
            })
    }

    reload = () => {
        this.table.current.reload();
    };


    changeStateValue = (v) => {
        let inputTypes = this.state.inputTypes
        inputTypes[2]['fields'][4].hidden = !v
        inputTypes[2]['fields'][5].hidden = !v
        inputTypes[2]['fields'][6].hidden = v
        this.setState({ inputTypes })
    }


    changeApplicationWaive = (v) => {
        let inputTypes = this.state.inputTypes
        inputTypes[2]['fields'][2].hidden = !v
        this.setState({ inputTypes })
    }

    loadCities = async id => {
        Request.loadCities(id)
            .then(data => {
                data.result = data.result.reduce((total, val) => {
                    total.push({
                        id: val._id,
                        _id: val.cityId,
                        display: val.cityName
                    })
                    return total
                }, [])

                let inputTypes = this.state.inputTypes
                inputTypes[0]['fields'][2].options = data.result
                inputTypes[1]['fields'][2].options = data.result
                this.setState({ inputTypes: inputTypes, citiesData: data.result })
                this.refreshFxn()
            })
            .catch(err => {
            })
    }
    loadRestrictedData = async () => {
        let restrictedUniversities = await Request.loadRestrictedUniversities({
            results: 100000
        });

        let restrictedUniversityArray = [{ display: '---Select All---', id: 'all' }];
        restrictedUniversities.data.reduce((total, val) => {
            restrictedUniversityArray.push({
                _id: val._id,
                display: val.universityName
            });
        }, []);
        let restrictedLocations = await Request.loadRestrictedLocations({
            results: 100000
        });
        let restrictedLocationsArray = [{ display: '---Select All---', id: 'all' }];
        restrictedLocations.data.reduce((total, val) => {
            restrictedLocationsArray.push({
                _id: val._id,
                display: val.locationName
            });
        }, []);
        let consortiumsDetails = await Request.getConsortiumsDetails({
            results: 1000,
            count: 1000
        });
        let consortiumsArray = [];
        consortiumsDetails.data.reduce((total, val) => {
            consortiumsArray.push({
                _id: val._id,
                display: val.consortiumName
            });
        }, []);
        this.setState({ restrictedUniversities: restrictedUniversityArray, restrictedLocations: restrictedLocationsArray, consortiumsArray: consortiumsArray })
    }
    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    exportExcel = async () => {
        this.setState({ exportLoading: true })
        let searchParams = new URLSearchParams(this.props.search)
        universityId = searchParams.get('id');
        let x = await Request.exportUniversityCoursesCsv(universityId);
        this.setState({ exportLoading: false })
        if (!x.error) {
            window.open(x.url)
        }
    }
    handleChange = async input => {
        if (input.fileList.length > 0) {
            if (input.fileList[0].response != undefined) {
                let searchParams = new URLSearchParams(this.props.search)
                universityId = searchParams.get('id');
                let data = {
                    universityId: universityId,
                    filePath: input.fileList[0].response.path
                }
                let x = await Request.importUniversityCoursesCsv(data, universityId);
                if (x) {
                    notification.success({
                        message: x.msg
                    })
                }
            }
        }
    }

    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    loadTestTypes = async () => {
        let params = {
            results: 10000,
            count: 10000
        }
        let response = await Request.getAllTestTypes(params)
        this.setState({ allTestTypes: response.data })
    }

    loadChannelPartners = async () => {
        let params = {
            results: 1000,
            count: 1000,
        }
        let response = await Request.loadChannelPartners(params);
        this.setState({ channelPartners: response.data })
    }

    viewAgreementCommissionPDF = e => {
        const { paymentUploadCommissionPage } = this.state;
        if (paymentUploadCommissionPage.length > 0) {
            let linkUrl = MEDIA_URL + paymentUploadCommissionPage[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl, showCommPage: true });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }

    viewPDF = e => {
        const { paymentUpload } = this.state;
        if (paymentUpload.length > 0) {
            let linkUrl = MEDIA_URL + paymentUpload[0].url;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (this.checkUrlExt(linkUrl)) {
                this.setState({ ext: ext, linkUrl: linkUrl });
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }

    updateNotificationField = (value) => {
        this.setState((prevState) => {
            const inputTypes = [...prevState.inputTypes]; // Create a copy of inputTypes
            const fields = [...inputTypes[0].fields]; // Create a copy of fields
            const fieldToUpdate = { ...fields[10] }; // Copy the specific field

            if (value === "Active") {
                fieldToUpdate.hidden = false;
                fieldToUpdate.required = true;
            } else {
                fieldToUpdate.hidden = true;
                fieldToUpdate.required = false;
            }

            fields[10] = fieldToUpdate; // Update the copied field
            inputTypes[0] = { ...inputTypes[0], fields }; // Update the copied inputTypes

            return { inputTypes }; // Update the state with the new object
        });
    };



    // updateNotificationField = (value) => {
    //     let inputTypes = this.state.inputTypes; 
    //     if(value === "Active") {
    //         inputTypes[0]['fields'][10].hidden = false;
    //         inputTypes[0]['fields'][10].required = true;
    //     }else {
    //         inputTypes[0]['fields'][10].hidden = true;
    //         inputTypes[0]['fields'][10].required = false;
    //     }
    //     this.setState({inputTypes})
    // }
    downloadPDF = () => {
        const { paymentUpload } = this.state;
        if (paymentUpload.length > 0) {
            let linkUrl = MEDIA_URL + paymentUpload[0].url;
            if (this.checkUrlExt(linkUrl)) {
                window.open(linkUrl, '_blank');
            } else {
                notification.warning({
                    message: 'Agreement not exists!!!.'
                })
            }
        }
    }
    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null, showCommPage: false });
    }

    constructor(props) {
        super(props)
        this.state = {
            showSave: 1,
            //showFiles: 0,
            refreshChild: false,
            paymentUpload: [],
            paymentUploadCommissionPage: [],
            activeKey: "1",
            ext: null,
            linkUrl: null,
            editIeltsIndex: 'false',
            ieltsScoreAcceptable: false,
            bachelorDegreeAcceptable: false,
            examType: '',
            listening: '',
            overall: '',
            reading: '',
            speaking: '',
            writing: '',
            courseId: "",
            list: [],
            courses: [],
            ieltsRequirements: [],
            restrictedUniversities: [],
            channelPartners: [],
            allTestTypes: [],
            restrictedLocations: [],
            subCampusList: [],
            applicantsList: [],
            phoneCodes: [],
            inputTypes: [
                {
                    tabTitle: 'General Info',
                    fields: [
                        {
                            label: 'Select Country ',
                            key: 'universityCountryId',
                            required: true,
                            showSearch: true,
                            type: 'select',
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityCountryId: v,
                                    universityStateId: null,
                                    universityCityId: null
                                })
                                this.loadStates(v)
                            }
                        },
                        {
                            label: 'Select State',
                            key: 'universityStateId',
                            required: true,
                            type: 'select',
                            showSearch: true,
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityStateId: v,
                                    universityCityId: null
                                })
                                this.loadCities(v)
                            }
                        },
                        {
                            label: 'Select City',
                            key: 'universityCityId',
                            required: true,
                            type: 'select',
                            showSearch: true,
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityCityId: v
                                })
                            }
                        },
                        {
                            label: 'Institute Name',
                            key: 'universityInstitutionName',
                            required: true
                        },
                        {
                            label: 'Agent Code',
                            key: 'agentCode',
                            type: 'text'
                        },
                        {
                            label: 'University Website ',
                            key: 'universityWebsite',
                            required: true
                        },
                        {
                            label: 'Type',
                            key: 'universityType',
                            type: 'select',
                            required: true,
                            options: ['Language School', 'School', 'College', 'University'],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityType: v
                                })
                            }
                        },
                        {
                            label: 'Category',
                            key: 'universityCategory',
                            type: 'select',
                            required: true,
                            options: [
                                'Government',
                                'Private',
                                'Not Specified',
                                'SPP',
                                'IPP',
                                'SVP'
                            ],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityCategory: v
                                })
                            }
                        },
                        {
                            label: 'Partnership',
                            key: 'universityPartnership',
                            type: 'select',
                            required: true,
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityPartnership: v
                                })
                            }
                        },
                        {
                            label: 'Status',
                            key: 'universityStatus',
                            type: 'select',
                            required: true,
                            options: [{ id: 'Active', display: 'Active' }, { id: 'Block', display: 'Block' }, { id: 'Expired', display: 'Expired' }, { id: 'Draft', display: 'Draft' }],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityStatus: v
                                }, () => {
                                    this.updateNotificationField(v)
                                })
                            }
                        },
                        {
                            label: 'GSTIN (if Applicable)',
                            key: 'gstNumber'
                        },
                        {
                            label: 'Pan Number (if Applicable)',
                            key: 'panNumber',
                        },
                        {
                            label: 'Send Notification',
                            key: 'sendNotification',
                            type: 'select',
                            options: [{ id: 'Yes', display: 'Yes' }, { id: 'No', display: 'No' }],
                            hidden: true,
                            required: false,
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    sendNotification: v
                                })
                            }
                        },
                        {
                            label: 'Currency',
                            key: 'universityCurrency',
                            type: 'text',
                        },
                        { label: 'Elicos', key: 'elicos' },
                        {
                            label: 'Training Video URL',
                            key: 'trainingVideoURL'
                        },
                        {
                            label: 'Availability Link',
                            key: 'availabilityLink'
                        },
                        {
                            label: 'PGWP Elgible Programs Link',
                            key: 'pgwpEnabledProgramsLink'
                        },
                        {
                            label: 'IELTS 5.5 (If acceptable in one module)',
                            key: 'ieltsScoreAcceptableUniversityBasis',
                            type: 'checkbox',
                            onClick: (v) => {
                                this.props.form.setFieldsValue({
                                    ieltsScoreAcceptableUniversityBasis: v.target.checked,
                                });
                            },
                        },
                        {
                            label: '3 Years Bachelor Degree Requirement',
                            key: 'bachelorDegreeRequirementUniversityBasis',
                            type: 'checkbox',
                            onClick: (v) => {
                                this.props.form.setFieldsValue({
                                    bachelorDegreeRequirementUniversityBasis: v.target.checked,
                                });
                            },
                        },
                        {
                            label: 'MOI',
                            key: 'moi',
                            type: 'checkbox',
                            onClick: (v) => {
                                this.props.form.setFieldsValue({
                                    moi: v.target.checked,
                                });
                            },
                        },
                        {
                            label: 'Preferred Partner',
                            key: 'preferredPartner',
                            type: 'checkbox',
                            onClick: (v) => {
                                this.props.form.setFieldsValue({
                                    preferredPartner: v.target.checked,
                                });
                            },
                        },
                        {
                            label: 'This Institution accepts previous visa refusal?',
                            key: 'acceptPreviousRefusal',
                            type: 'select',
                            options: ['Yes', "No"],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    acceptPreviousRefusal: v
                                })
                            }
                        }
                    ]
                },
                {
                    tabTitle: 'Sub Campus',
                    fields: [
                        {
                            label: 'Select Country ',
                            key: 'universityCountryId',
                            required: true,
                            showSearch: true,
                            type: 'select',
                            options: [],
                            hidden: true,
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityCountryId: v,
                                    universityStateId: null,
                                    universityCityId: null
                                })
                                this.loadStates(v)
                            }
                        },
                        {
                            label: 'Select State',
                            key: 'universityStateId',
                            required: true,
                            type: 'select',
                            showSearch: true,
                            options: [],
                            hidden: true,
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityStateId: v,
                                    universityCityId: null
                                })
                                this.loadCities(v)
                            }
                        },
                        {
                            label: 'Select City',
                            key: 'universityCityId',
                            required: true,
                            type: 'select',
                            hidden: true,
                            showSearch: true,
                            options: [],
                            onChange: v => {
                                this.props.form.setFieldsValue({
                                    universityCityId: v
                                })
                            }
                        },
                    ]
                },
                {
                    tabTitle: 'Contacts',
                    fields: [
                        {
                            label: 'Address',
                            key: 'contactAddress',
                            type: 'textArea',
                            rows: '5'
                        },
                        {
                            label: 'Waive Application Fee',
                            key: 'waiveApplicationFee',
                            type: 'switch',
                            onChange: v => {
                                this.props.form.setFieldsValue({ waiveApplicationFee: v })
                                this.changeApplicationWaive(v)
                            }
                        },
                        {
                            label: 'Waived Until',
                            key: 'applicationFeeWaivedUntil',
                            type: 'date',
                            hidden: true
                        },
                        {
                            label: 'Different Application Fee UG/PG ?',
                            key: 'differentApplicationFee',
                            type: 'switch',
                            onChange: v => {
                                this.props.form.setFieldsValue({ differentApplicationFee: v })
                                this.changeStateValue(v)
                            }
                        },
                        {
                            label: 'UG Application Fee',
                            key: 'contactApplicationFeeUG',
                            type: 'number',
                            hidden: true,
                        },
                        {
                            label: 'PG Application Fee',
                            key: 'contactApplicationFeePG',
                            type: 'number',
                            hidden: true,
                        },
                        {
                            label: 'Application Fee',
                            key: 'contactAppilcationFee',
                            type: 'number',
                            hidden: false,
                        },
                        {
                            label: 'Logo',
                            key: 'contactLogo',
                            type: 'file',
                            limit: 1
                        },
                        {
                            label: 'Name',
                            key: 'contactNameOne',
                            prefixComp: <h3>Admission Person1</h3>
                        },
                        {
                            label: "Country Code",
                            key: "contactPhoneOneCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactPhoneOneCode: v });
                            },
                        },
                        {
                            label: 'Phone ',
                            key: 'contactPhoneOne',
                            type: 'number'
                        },
                        {
                            label: 'Email ',
                            key: 'contactEmailOne',
                            type: 'email'
                        },
                        {
                            label: 'Name',
                            key: 'contactNameTwo',
                            prefixComp: <h3>Admission Person2</h3>
                        },
                        {
                            label: "Country Code",
                            key: "contactPhoneTwoCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactPhoneTwoCode: v });
                            },
                        },
                        {
                            label: 'Phone',
                            key: 'contactPhoneTwo',
                            type: 'number'
                        },
                        {
                            label: 'Email',
                            key: 'contactEmailTwo',
                            type: 'email'
                        },
                        {
                            label: 'Name',
                            key: 'contactNameThree',
                            prefixComp: <h3>Marketing Person</h3>
                        },
                        {
                            label: "Country Code",
                            key: "contactPhoneThreeCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactPhoneThreeCode: v });
                            },
                        },
                        {
                            label: 'Phone',
                            key: 'contactPhoneThree',
                            type: 'number'
                        },
                        {
                            label: 'Email',
                            key: 'contactEmailThree',
                            type: 'email'
                        },
                        {
                            label: 'Name',
                            key: 'contactAccountName',
                            prefixComp: <h3>Accounts Person</h3>
                        },

                        {
                            label: "Country Code",
                            key: "contactAccountPhoneCode",
                            type: "select",
                            showSearch: true,
                            options: [],
                            onChange: (v) => {
                                this.props.form.setFieldsValue({ contactAccountPhoneCode: v });
                            },
                        },
                        {
                            label: 'Phone',
                            key: 'contactAccountPhone',
                            type: 'number'
                        },
                        {
                            label: 'Email',
                            key: 'contactAccountEmail',
                            type: 'email'
                        },
                        {
                            label: 'Address',
                            key: 'contactAccountAddress',
                            type: 'textArea',
                            rows: '5'
                        }
                    ]
                },
                {
                    tabTitle: 'Enrollment Procedure',
                    fields: [
                        {
                            label: 'Document Checklist',
                            key: 'enrollmentDocuments',
                            type: 'textArea',
                            rows: '5'
                        },
                        {
                            label: 'Any Remarks / Prospectus',
                            key: 'enrollmentRemarks',
                            type: 'textArea',
                            rows: '5'
                        },
                        {
                            label: 'Admission Procedure Steps',
                            key: 'enrollmentProcedure',
                            type: 'textArea',
                            rows: '5'
                        },
                        {
                            label: 'Admission Offer Processing Time',
                            key: 'enrollmentAdmissionOffer'
                        },
                        {
                            label: 'Enrollment Confirmation Processing Time',
                            key: 'enrollmentConfirmation'
                        }
                    ]
                },
                {
                    tabTitle: 'Agreement Details',
                    fields: [
                        {
                            label: 'Signing Date',
                            key: 'agreementSigningDate',
                            type: 'date',
                            format: 'DD-MMM-YYYY'
                        },
                        {
                            label: 'Does This Agreement has Expiry?',
                            key: 'isAgreementExpire',
                            default: false,
                            type: 'switch',
                            onChange: checked => {
                                this.props.form.setFieldsValue({ isAgreementExpire: checked }, () => {
                                    this.updateSwitch(checked)
                                })
                            }
                        },
                        {
                            label: 'Expiry Date',
                            key: 'enrollmentExpiry',
                            hidden: true,
                            required: false,
                            type: 'date',
                            format: 'DD-MMM-YYYY'
                        },
                        {
                            label: 'Renewal Reminder Date',
                            key: 'enrollmentRenewal',
                            hidden: true,
                            required: false,
                            type: 'date',
                            format: 'DD-MMM-YYYY'
                        },
                        {
                            label: 'Agreement Document',
                            key: 'paymentUpload',
                            type: 'file'
                        },
                        {
                            label: 'Agreement Commission Page Document',
                            key: 'paymentUploadCommissionPage',
                            type: 'file'
                        },
                        {
                            label: 'Institutional Targets/Year',
                            key: 'institutionalTargets',
                            type: 'number'
                        }
                    ]
                },
                {
                    tabTitle: 'Entry Requirements',
                    fields: []
                }
                // {
                //     tabTitle: 'Commission Notes',
                //     opened: false,
                //     fields: [
                //         {
                //             label: 'Language',
                //             key: 'language',
                //             type: 'number'
                //         },
                //         {
                //             label: 'Foundation',
                //             key: 'foundation',
                //             type: 'number'
                //         },
                //         {
                //             label: 'Flat Amount',
                //             key: 'flatAmount',
                //             type: 'number'
                //         },
                //         {
                //             label: 'Undergraduate',
                //             key: 'undergraduate',
                //             type: 'number'
                //         },
                //         {
                //             label: 'Postgraduate',
                //             key: 'postgraduate',
                //             type: 'number'
                //         },
                //         {
                //             label: 'PAYMENT Terms',
                //             key: 'paymentTerms',
                //             type: 'textArea',
                //             rows: '5'
                //         }
                //     ]
                // }
            ],
            enrollmentList: [],
            subCampusList: [],
            filesLibraryList: [],
            citiesData: [],
            countriesData: [],
            statesData: [],
            filename: '',
            desc: '',
            branch: '',
            institutionalIncentive: '',
            subCampusName: '',
            subCampusState: '',
            subCampusCity: null,
            subCampusStatus: '',
            partnershipArr: [],
            subCampusPartnership: null,
            subCampusChannelPartner: null,
            showApplicantModal: false,
            editIndex: null
        }
        this.loadCountries();

        this.loadRestrictedData();
    }

    handleCountryChange = (value) => {
        this.loadStates(value)
    }


    updateSwitch = (checked) => {
        let inputTypes = this.state.inputTypes
        inputTypes[4]['fields'][2].hidden = checked ? true : false
        inputTypes[4]['fields'][3].hidden = checked ? true : false
        inputTypes[4]['fields'][2].required = checked ? false : true
        inputTypes[4]['fields'][3].required = checked ? false : true
        this.setState({ inputTypes })
    }


    loadUniversityPartnership = async () => {
        let params = {
            results: 1000,
            count: 1000
        }
        let response = await Request.getAllUniversityPartnership(params)
        let partnershipData = []
        _.each(response.data, (item) => {
            partnershipData.push({ id: item.partnershipName, display: item.partnershipName })
        })
        let inputTypes = this.state.inputTypes
        inputTypes[0].fields[8].options = partnershipData
        this.setState({ inputTypes, partnershipArr: response.data })
    }
    handleStateChange = (value) => {
        this.loadCities(value)
        this.setState({ subCampusState: value })
    }
    handleCityChange = (value) => {
        this.setState({ subCampusCity: value })
    }
    componentDidMount() {
        this.loadCountries();
        this.loadUniversityPartnership()
        let searchParams = new URLSearchParams(this.props.search)
        universityId = searchParams.get('id')
        let tabId = searchParams.get('tab')
        this.loadTestTypes()
        setTimeout(() => {
            this.setState({ activeKey: tabId })
        }, 10)
        if (universityId) {
            this.setState({ universityId })
            //   this.setState({ showFiles: 1 })
            this.setFormValues(universityId)
        }
    }
    onSave = (index) => {
        const { form } = this.props
        let x = form.getFieldsValue(['qualification', 'percentage', 'maths', 'english', 'stream', 'major', 'passingYear', 'backlogs', 'degreeType'])
        let editedData = [...this.state.list]
        editedData[index] = { ...x }
        this.setState({ list: editedData }, () => {
        })

    }

    changeBachelorDegreeAcceptable = (e) => {
        this.setState({
            bachelorDegreeAcceptable: e.currentTarget.value == 'true' ? true : false
        });
    }

    changeIeltsScoreAcceptable = (e) => {
        this.setState({
            ieltsScoreAcceptable: e.currentTarget.value == 'true' ? true : false
        });
    }

    editIeltsRequirement = (index, record) => {
        this.setState({ editIeltsIndex: index, examType: record.ExamType, listening: record.Listening, overall: record.Overall, reading: record.Reading, speaking: record.Speaking, writing: record.Writing })
    }

    updateIeltsRequirement = () => {
        let { editIeltsIndex, examType, listening, reading, overall, speaking, writing, ieltsRequirements } = this.state;
        if (ieltsRequirements[editIeltsIndex] == undefined) {
            ieltsRequirements[editIeltsIndex] = [];
        }
        ieltsRequirements[editIeltsIndex].ExamType = examType
        ieltsRequirements[editIeltsIndex].Overall = overall
        ieltsRequirements[editIeltsIndex].Listening = listening
        ieltsRequirements[editIeltsIndex].Reading = reading
        ieltsRequirements[editIeltsIndex].Writing = writing
        ieltsRequirements[editIeltsIndex].Speaking = speaking;
        this.setState({ editIeltsIndex: 'false', ieltsRequirements: ieltsRequirements, examType: '', listening: '', overall: '', reading: '', speaking: '', writing: '' });
    }

    editApplicant = (record, index) => {

        this.setState({
            showApplicantModal: true,
            editIndex: index
        });

        this.props.form.setFieldsValue({
            type: record.type,
            invoiceToName: record.invoiceToName,
            invoiceAddress: record.invoiceAddress,
            kindAttention: record.kindAttention,
            invoiceToEmail: record.invoiceToEmail,
            invoiceToPhoneCode: record.invoiceToPhoneCode,
            invoiceToPhone: record.invoiceToPhone,
            invoiceToCategory: record.invoiceToCategory,
            default: record.default
        });
    };

    render() {
        const { submitting } = this.props
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props

        const { paymentUpload, paymentUploadCommissionPage, restrictedLocations, courseId, partnershipArr, restrictedUniversities, consortiumsArray = [], list, phoneCodes } = this.state;
        const newComissionSchema = {
            fields: [
                {
                    label: 'Type',
                    key: 'type',
                    type: 'select',
                    options: ['Domestic', 'International'],
                    onChange: v => {
                        setFieldsValue({ type: v })
                    }
                },
                {
                    label: 'Invoice To',
                    key: 'invoiceToName',
                },
                {
                    label: 'Invoice Address',
                    key: 'invoiceAddress',
                },
                {
                    label: 'Kind Attention',
                    key: 'kindAttention',
                },
                {
                    label: 'Invoice Email',
                    key: 'invoiceToEmail',
                },
                {
                    label: 'Invoice Country Code',
                    key: 'invoiceToPhoneCode',
                    type: 'select',
                    options: this.state.phoneCodes,
                    showSearch: true,
                    onChange: v => {
                        setFieldsValue({ invoiceToPhoneCode: v })
                    }
                },
                {
                    label: 'Invoice Contact',
                    key: 'invoiceToPhone',
                },
                {
                    label: 'Invoice Category',
                    key: 'invoiceToCategory',
                },
                {
                    label: 'Is This Default Invoice Recipient?',
                    key: 'default',
                    type: 'switch',
                    onChange: v => {
                        setFieldsValue({ default: v })
                    }
                }
            ]
        }
        const columns1 = [
            {
                title: 'Qualification',
                key: 'qualification',
                dataIndex: 'qualification',
                searchTextName: '',
                filterRegex: true,
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('qualification', { initialValue: record.qualification ? record.qualification : null })(
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                onChange={(qualification) => {
                                    record.qualification = qualification
                                }}
                            ><Option value={'X'}>X</Option>
                                <Option value={'XII'}>XII</Option>
                                <Option value={'Diploma'}>Diploma</Option>
                                <Option value={'Bachelor Degree'}>Bachelor Degree</Option>
                                <Option value={'Post Graduation'}>Post Graduation</Option>
                            </Select>)}
                    </Form.Item> : item}</>
                }
            },
            {
                title: 'Qualification Status',
                key: 'qualificationStatus',
                dataIndex: 'qualificationStatus',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('qualificationStatus', { initialValue: record.qualificationStatus ? record.qualificationStatus : null })(
                            <InputNumber
                            />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'Grading System',
                key: 'gradingSystem',
                dataIndex: 'gradingSystem',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('gradingSystem', { initialValue: record.gradingSystem ? record.gradingSystem : null })(
                            <InputNumber
                            />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'Score ',
                key: 'score',
                dataIndex: 'score',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('score', { initialValue: record.score ? record.score : null })(
                            <InputNumber
                            />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'Maths ',
                key: 'maths',
                dataIndex: 'maths',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('maths', { initialValue: record.maths ? record.maths : null })(<InputNumber />)}
                    </Form.Item> : item}</>
                }

            },
            {
                title: 'English ',
                key: 'english',
                dataIndex: 'english',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('english', { initialValue: record.english ? record.english : null })(
                            <InputNumber />)}
                    </Form.Item> : item}</>
                }
            },
            {
                title: 'Stream ',
                key: 'stream',
                dataIndex: 'stream',
                render: (item, record) => {
                    return <><Form.Item>
                        {getFieldDecorator('stream', { initialValue: record.stream ? record.stream : null })(<Select
                            showSearch={true}
                            style={{ width: '100%' }}
                            dropdownMatchSelectWidth={false}
                            mode={'multiple'}
                        >
                            <Option value={'MEDICAL'}>MEDICAL</Option>
                            <Option value={'NON-MEDICAL'}>NON-MEDICAL</Option>
                            <Option value={'COMMERCE'}>COMMERCE</Option>
                            <Option value={'ARTS'}>ARTS</Option>
                        </Select>)}
                    </Form.Item></>
                }
            },
            // {
            //     title: 'Major Subjects',
            //     key: 'major',
            //     dataIndex: 'major',
            //     render: (item, record) => {
            //         return <>{record.editable ? <Form.Item>
            //             {getFieldDecorator('major', {initialValue: record.major ? record.major : null})(<Select
            //                 mode="tags"
            //                 style={{width: '100%'}}
            //                 placeholder="Tags Mode"
            //             />)}
            //         </Form.Item> : item && item.map(ii => <Tag>{ii}</Tag>)}</>
            //     }
            // },
            {
                title: 'Backlogs ',
                key: 'backlogs',
                dataIndex: 'backlogs',
                render: (item, record) => {
                    return <>{record.editable ? <Form.Item>
                        {getFieldDecorator('backlogs', { initialValue: record.backlogs ? record.backlogs : null })(
                            <InputNumber />)}
                    </Form.Item> : item}</>
                }
            },
            {
                title: 'Degree Type ',
                key: 'degreeType',
                dataIndex: 'degreeType',
                render: (item, record) => {
                    let condition = record.qualification == 'Diploma' || record.qualification == 'Bachelor Degree' || record.qualification == 'Post Graduation'
                    return <>{record.editable ?
                        <Form.Item>
                            {getFieldDecorator('degreeType', { initialValue: record.degreeType ? record.degreeType : null })
                                (<Select
                                    showSearch
                                    style={{ width: '100%' }}
                                >{condition ? typeofDegree[record.qualification].map((val, index) => {
                                    return (
                                        <Option key={index} value={val.value}>
                                            {val.value}
                                        </Option>
                                    )
                                }) : []}
                                </Select>)}
                        </Form.Item> : item}</>
                }
            },
            {
                title: 'Action',
                key: 'operation',
                icon: 'trash',
                fixed: 'right',
                render: (val, record, key) => {
                    return (<React.Fragment>
                        <Tooltip title="Delete">
                            <Button
                                shape="circle"
                                onClick={() => {
                                    let tt = this.state.list
                                    tt = _.reject(tt, val)
                                    this.setState({ list: tt })
                                }}
                                icon="delete"
                                size={'small'}
                            />
                        </Tooltip>
                        {!record.editable && <Tooltip title="Edit">
                            <Button
                                shape="circle"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    let newData = [...this.state.list]
                                    newData = _.map(newData, (item) => {
                                        item.editable = false
                                        return item
                                    })
                                    newData[key] = { ...record, editable: true }
                                    this.setState({ list: newData })

                                }}
                                icon="edit"
                                size={'small'}
                            />
                        </Tooltip>}

                        {record.editable && <a style={{ color: 'orange', marginLeft: '5px' }} onClick={() => {
                            this.onSave(key)
                        }}>Save</a>}
                    </React.Fragment>)
                }
            }
        ]
        const ieltsColumn = [
            { title: 'Exam', key: 'examType', dataIndex: 'ExamType' },
            { title: 'Overall', key: 'overall', dataIndex: 'Overall' },
            { title: 'Listening', key: 'listening', dataIndex: 'Listening' },
            { title: 'Reading', key: 'reading', dataIndex: 'Reading' },
            { title: 'Writing', key: 'writing', dataIndex: 'Writing' },
            { title: 'Speaking', key: 'speaking', dataIndex: 'Speaking' },
            {
                title: 'Action',
                key: 'action',
                dataIndex: 'action',
                render: (val, record, index) => {
                    return (
                        <>
                            <a
                                size="small"
                                onClick={() => { this.editIeltsRequirement(index, record) }}>
                                Edit
                            </a>&nbsp;|&nbsp;
                            <a
                                size="small"
                                onClick={() => {
                                    let tempArr = _.reject(this.state.ieltsRequirements, val => {
                                        return val == record
                                    })
                                    this.setState({ ieltsRequirements: tempArr })
                                }}>
                                Remove
                            </a>
                        </>
                    )
                }
            }
        ]

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                md: { span: 4 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                md: { span: 8 },
                sm: { span: 12 }
            }
        }

        const submitFormLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 10, offset: 7 },
                md: { span: 12, offset: 8 }
            }
        }

        const subCampusColumns = [
            { title: 'Campus Name', key: 'campusName', dataIndex: 'campusName' },
            {
                title: 'State', key: 'state.name', dataIndex: 'state.name',
            },
            {
                title: 'City', key: 'city.name', dataIndex: 'city.name',
            },
            {
                title: 'Campus Partnership', key: 'campusPartnership', dataIndex: 'campusPartnership'
            },
            {
                title: 'Channel Partner Name', key: 'channelPartner.name', dataIndex: 'channelPartner.name'
            },
            { title: 'Status', key: 'status', dataIndex: 'status' }
        ]
        const columns = [
            { title: 'University', key: 'filename', dataIndex: 'filename' },
            { title: 'Country', key: 'desc', dataIndex: 'desc' },
            { title: 'Website', key: 'branch', dataIndex: 'branch' },
            {
                title: 'Action',
                key: 'action',
                render: (val, record) => {
                    return (
                        <a
                            size="small"
                            onClick={c => {
                                let tempArr = _.reject(this.state.enrollmentList, val => {
                                    return val == record
                                })
                                this.setState({ enrollmentList: tempArr })
                            }}>
                            Remove
                        </a>
                    )
                }
            }
        ]
        const editRequirements = {
            fields: [
                {
                    label: 'Select Courses',
                    key: 'selectCourse',
                    type: 'select',
                    options: this.state.courses,
                    mode: 'multiple',
                    onChange: v => {
                        this.props.form.setFieldsValue({ selectCourse: v })
                    }
                }
            ]
        }
        const universityRestrictedColumns = {
            fields: [
                {
                    label: 'Select Group (If Any)',
                    key: 'consortiumId',
                    type: 'select',
                    // showSearch: true,
                    options: [{ id: "Clear", display: 'Clear Selection' }, ...consortiumsArray],
                    // options: consortiumsArray,
                    allowClear: true,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            consortiumId: v
                        })
                    }
                },
                {
                    label: 'Select If Any Restricted Location',
                    key: 'restrictedLocationId',
                    type: 'select',
                    showSearch: true,
                    mode: 'multiple',
                    options: restrictedLocations,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === restrictedLocations.length) {
                                val = [];
                            } else {
                                val = restrictedLocations.slice(1).map(restrictedLocation => restrictedLocation._id);
                            }
                        }
                        this.props.form.setFieldsValue({
                            restrictedLocationId: val
                        })
                    }
                },
                {
                    label: 'Select If Any Restricted Local University',
                    key: 'restrictedLocalUniversityId',
                    type: 'select',
                    showSearch: true,
                    mode: 'multiple',
                    options: restrictedUniversities,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === restrictedUniversities.length) {
                                val = [];
                            } else {
                                val = restrictedUniversities.slice(1).map(restrictedUniversity => restrictedUniversity._id);
                            }
                        }
                        this.props.form.setFieldsValue({
                            restrictedLocalUniversityId: val
                        })
                    }
                },
            ]
        }



        const applicantListColumns = [
            {
                title: 'Type',
                key: 'type',
                dataIndex: 'type'
            },
            {
                title: 'Invoice To',
                key: 'invoiceToName',
                dataIndex: 'invoiceToName',
            },
            {
                title: 'Invoice Address',
                key: 'invoiceAddress',
                dataIndex: 'invoiceAddress',
            },
            {
                title: 'Kind Attention',
                key: 'kindAttention',
                dataIndex: 'kindAttention',
            },
            {
                title: 'Invoice Email',
                key: 'invoiceToEmail',
                dataIndex: 'invoiceToEmail',
            },
            {
                title: 'Invoice Contact',
                key: 'invoiceToPhone',
                dataIndex: 'invoiceToPhone',
                render: (text, record) => (
                    <div>{record && record.invoiceToPhoneCode}-{record && record.invoiceToPhone}</div>
                )
            },
            {
                title: 'Invoice Category',
                key: 'invoiceToCategory',
                dataIndex: 'invoiceToCategory',
            },
            {
                title: 'Default Recipient',
                key: 'default',
                render: (text, record) => (
                    <div>{record && record.default ? "Yes" : "No"}</div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record, index) => (
                    <>
                        <Tooltip title="Edit Billing Detail">
                            <Button shape="circle" icon='edit' onClick={() => this.editApplicant(record, index)} />
                        </Tooltip>
                        <Tooltip title="Delete Billing Detail">
                            <Button
                                shape="circle"
                                onClick={() => {
                                    this.removeCommissionRow(index)
                                }}
                                icon="delete"
                            />
                        </Tooltip>

                    </>
                )
            }
        ]

        var ext = this.state.ext;
        var linkUrl = this.state.linkUrl;

        return (
            <PageHeaderWrapper title={universityId ? 'Update University' : 'Add New University'}>
                {
                    ext != null && paymentUpload.length > 0 ?
                        <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                        : null
                }
                {
                    ext != null && paymentUploadCommissionPage.length > 0 && this.state.showCommPage ?
                        <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                        : null
                }
                <Form onSubmit={this.handleSubmit} name="asdf" style={{ marginTop: 8 }}>
                    <Card bordered={true}>
                        {this.state.showSave ? (
                            <Button
                                type="primary"
                                style={{ marginBottom: 10 }}
                                htmlType="submit"
                                loading={this.props.loading}>
                                SAVE
                            </Button>
                        ) : null}

                        <Tabs defaultActiveKey={this.state.activeKey} onChange={this.callback} type="card">
                            {this.state.inputTypes.map((itype, key) => {
                                return (
                                    <TabPane tab={itype.tabTitle} key={key + 1}>
                                        <GetAllFormFields
                                            apiurl={LAPI_URL}
                                            inputSchema={this.state.inputTypes[key]}
                                            refresh={this.refreshFxn}
                                            getFieldDecorator={getFieldDecorator}
                                        />
                                        {key == 0 ? (
                                            <GetAllFormFields
                                                apiurl={LAPI_URL}
                                                inputSchema={universityRestrictedColumns}
                                                refresh={this.refreshFxn}
                                                getFieldDecorator={getFieldDecorator}
                                            />
                                        ) : null}
                                        {
                                            key == 1 ? (
                                                <Card>
                                                    <Row>
                                                        {/* Inputs Sub Campus */}
                                                        <Col span={22}>
                                                            {/* Row 1 */}
                                                            <Row>
                                                                <Col span={5}>
                                                                    <Row>
                                                                        <Col span={24}>Enter Campus Name</Col>
                                                                        <Col span={24}>
                                                                            <Input onChange={ei => {
                                                                                this.setState({ subCampusName: ei.target.value })
                                                                            }} value={this.state.subCampusName} />
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={5} style={{ marginLeft: '10px' }}>
                                                                    <Row>
                                                                        <Col span={24}>Select State</Col>
                                                                        <Col span={24}>
                                                                            <Select value={this.state.subCampusState} onChange={this.handleStateChange}>
                                                                                {this.state.statesData.map((state, index) => (
                                                                                    <Option key={index} value={state._id}>{state.display}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={5} style={{ marginLeft: '10px' }}>
                                                                    <Row>
                                                                        <Col span={24}>Select City</Col>
                                                                        <Col span={24}>
                                                                            <Select value={this.state.subCampusCity} onChange={this.handleCityChange}>
                                                                                {this.state.citiesData.map((city, index) => (
                                                                                    <Option key={index} value={city._id}>{city.display}</Option>
                                                                                ))}
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={4} style={{ marginLeft: '10px' }}>
                                                                    <Row>
                                                                        <Col span={24}>Status</Col>
                                                                        <Col span={24}>
                                                                            <Select value={this.state.subCampusStatus} onChange={e => {
                                                                                this.setState({ subCampusStatus: e })
                                                                            }}>
                                                                                <Option value="Active">Active</Option>
                                                                                <Option value="Inactive">Inactive</Option>
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col span={4} style={{ marginLeft: '10px' }}>
                                                                    <Row>
                                                                        <Col span={24}>Campus Partnership</Col>
                                                                        <Col span={24}>
                                                                            <Select value={this.state.subCampusPartnership} onChange={e => {
                                                                                this.setState({ subCampusPartnership: e }, () => {
                                                                                    this.loadChannelPartners()
                                                                                })
                                                                            }}>
                                                                                {
                                                                                    partnershipArr.map((partnership, index) => (
                                                                                        <Option value={partnership.partnershipName}>{partnership.partnershipName}</Option>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>

                                                            {/* Row 2 */}
                                                            <Row gutter={16}>
                                                                {/* <Col span={4} style={{ marginTop: '10px' }}>
                                                                    <Row>
                                                                        <Col span={24}>Campus Partnership</Col>
                                                                        <Col span={24}>
                                                                            <Select value={this.state.subCampusPartnership} onChange={e => {
                                                                                this.setState({ subCampusPartnership: e }, () => {
                                                                                    this.loadChannelPartners()
                                                                                })
                                                                            }}>
                                                                                {
                                                                                    partnershipArr.map((partnership, index) => (
                                                                                        <Option value={partnership.partnershipName}>{partnership.partnershipName}</Option>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        </Col>
                                                                    </Row>
                                                                </Col> */}
                                                                {this.state.subCampusPartnership === "Channel Partner" ?
                                                                    <Col span={4} style={{ marginTop: '10px' }}>
                                                                        <Row>
                                                                            <Col span={24}>Channel Partner Name</Col>
                                                                            <Col span={24}>
                                                                                <Select value={this.state.subCampusChannelPartner} onChange={e => {
                                                                                    this.setState({ subCampusChannelPartner: e })
                                                                                }}>
                                                                                    {
                                                                                        this.state.channelPartners.map((partner, index) => (
                                                                                            <Option value={partner._id}>{partner.channelPartnerName}</Option>
                                                                                        ))
                                                                                    }
                                                                                </Select>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    : null}
                                                            </Row>
                                                        </Col>
                                                        {/* Button Sub Campus */}
                                                        <Col span={2} style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                                                            <Row>
                                                                <Col span={24}></Col>
                                                                <Col span={24} style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                                                                    <Button
                                                                        size={'small'}
                                                                        type="primary"
                                                                        style={{ marginLeft: 20 }}
                                                                        onClick={() => {
                                                                            this.addSubCampus()
                                                                        }}>
                                                                        Add
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: 40 }}>
                                                        <Col span={24}>
                                                            <TableComp
                                                                bordered={true}
                                                                columns={subCampusColumns}
                                                                dataSource={this.state.subCampusList || []}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            ) : null
                                        }
                                        {/* {
                                            key == 1 ? (
                                                <Card>
                                                    <Row>
                                                        <Col span={5}>
                                                            <Row>
                                                                <Col span={24}>Enter Campus Name</Col>
                                                                <Col span={24}>
                                                                    <Input onChange={ei => {
                                                                        this.setState({ subCampusName: ei.target.value })
                                                                    }} value={this.state.subCampusName} />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={5} style={{ marginLeft: '10px' }}>
                                                            <Row>
                                                                <Col span={24}>Select State</Col>
                                                                <Col span={24}>
                                                                    <Select value={this.state.subCampusState} onChange={this.handleStateChange}>
                                                                        {this.state.statesData.map((state, index) => (
                                                                            <Option key={index} value={state._id}>{state.display}</Option>
                                                                        ))}
                                                                    </Select>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={5} style={{ marginLeft: '10px' }}>
                                                            <Row>
                                                                <Col span={24}>Select City</Col>
                                                                <Col span={24}>
                                                                    <Select value={this.state.subCampusCity} onChange={this.handleCityChange}>
                                                                        {this.state.citiesData.map((city, index) => (
                                                                            <Option key={index} value={city._id}>{city.display}</Option>
                                                                        ))}
                                                                    </Select>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={4} style={{ marginLeft: '10px' }}>
                                                            <Row>
                                                                <Col span={24}>Status</Col>
                                                                <Col span={24}>
                                                                    <Select value={this.state.subCampusStatus} onChange={e => {
                                                                        this.setState({ subCampusStatus: e })
                                                                    }}>
                                                                        <Option value="Active">Active</Option>
                                                                        <Option value="Inactive">Inactive</Option>
                                                                    </Select>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={4}>
                                                            <Row>
                                                                <Col span={24}></Col>
                                                                <Col span={24} style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                                                                    <Button
                                                                        size={'small'}
                                                                        type="primary"
                                                                        style={{ marginLeft: 20 }}
                                                                        onClick={() => {
                                                                            this.addSubCampus()
                                                                        }}>
                                                                        Add
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row gutter={16}>
                                                        <Col span={4} style={{ marginTop: '10px' }}>
                                                            <Row>
                                                                <Col span={24}>Campus Partnership</Col>
                                                                <Col span={24}>
                                                                    <Select value={this.state.subCampusPartnership} onChange={e => {
                                                                        this.setState({ subCampusPartnership: e }, () => {
                                                                            this.loadChannelPartners()
                                                                        })
                                                                    }}>
                                                                        {
                                                                            partnershipArr.map((partnership, index) => (
                                                                                <Option value={partnership.partnershipName}>{partnership.partnershipName}</Option>
                                                                            ))
                                                                        }
                                                                    </Select>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        {this.state.subCampusPartnership === "Channel Partner" ?
                                                            <Col span={4} style={{ marginLeft: '10px', marginTop: '10px' }}>
                                                                <Row>
                                                                    <Col span={24}>Channel Partner</Col>
                                                                    <Col span={24}>
                                                                        <Select value={this.state.subCampusChannelPartner} onChange={e => {
                                                                            this.setState({ subCampusChannelPartner: e })
                                                                        }}>
                                                                            {
                                                                                this.state.channelPartners.map((partner, index) => (
                                                                                    <Option value={partner._id}>{partner.channelPartnerName}</Option>
                                                                                ))
                                                                            }
                                                                        </Select>
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                            : null}
                                                    </Row>
                                                    <Row style={{ marginTop: 40 }}>
                                                        <Col span={24}>
                                                            <Table
                                                                bordered={true}
                                                                columns={subCampusColumns}
                                                                dataSource={this.state.subCampusList}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            ) : null
                                        } */}
                                        {key == 4 && paymentUpload && paymentUpload.length > 0 ? (
                                            <Row>
                                                <Col span={6}></Col>
                                                <Col span={6}>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Button onClick={this.viewPDF}>
                                                                View Agreement
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={6}>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Button onClick={this.viewAgreementCommissionPDF}>
                                                                View Commission Page
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={6}>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Button onClick={this.downloadPDF}>
                                                                Download Agreement
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        ) : null}
                                        {key == 2 ? (
                                            <Card>
                                                <h4>Enrollment Lists</h4>
                                                <Row>
                                                    <Col span={6}>
                                                        <Row>
                                                            <Col span={24}>Institute </Col>
                                                            <Col span={24}>
                                                                <input
                                                                    ref={el => (this.ei = el)}
                                                                    //required
                                                                    onChange={ei => {
                                                                        this.setState({ ei: ei.target.value })
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Row>
                                                            <Col span={24}>Country </Col>
                                                            <Col span={24}>
                                                                <input
                                                                    ref={el => (this.ec = el)}
                                                                    onChange={ei => {
                                                                        this.setState({ ec: ei.target.value })
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Row>
                                                            <Col span={24}>Website </Col>
                                                            <Col span={24}>
                                                                <input
                                                                    ref={el => (this.ew = el)}
                                                                    onChange={ei => {
                                                                        this.setState({ ew: ei.target.value })
                                                                    }}
                                                                />

                                                                <Button
                                                                    size={'small'}
                                                                    style={{ marginLeft: 20 }}
                                                                    onClick={() => {
                                                                        this.addEnrollment()
                                                                    }}>
                                                                    Add
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                <Row style={{ marginTop: 40 }}>
                                                    <Col span={24}>
                                                        <Table
                                                            bordered={true}
                                                            columns={columns}
                                                            dataSource={this.state.enrollmentList}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Card>
                                        ) : null}

                                        {key == 5 ? (
                                            <div>
                                                <Card className={style.cardsep}>
                                                    <h4>English Requirements:</h4>
                                                    <h6>Overall Each band score:</h6>
                                                    <Row>
                                                        <Col span={8}>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Select
                                                                        placeholder={'Choose Exam'}
                                                                        value={this.state.examType}
                                                                        style={{ width: 90 }}
                                                                        className={style.inputNumber}
                                                                        onChange={ei => {
                                                                            this.setState({ examType: ei })
                                                                        }}>
                                                                        {
                                                                            this.state.allTestTypes.map(({ testType }) => {
                                                                                return (
                                                                                    <Option value={testType}>{testType}</Option>
                                                                                )

                                                                            })
                                                                        }
                                                                    </Select>
                                                                </Col>

                                                                <Col span={24}>
                                                                    <InputNumber
                                                                        className={style.inputNumber}
                                                                        value={this.state.overall}
                                                                        placeholder={'Overall'}
                                                                        type={'number'}
                                                                        ref={el => (this.overall = el)}
                                                                        onChange={ei => {
                                                                            this.setState({ overall: ei })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <InputNumber
                                                                        className={style.inputNumber}
                                                                        value={this.state.listening}
                                                                        placeholder={'Listening'}
                                                                        type={'number'}
                                                                        ref={el => (this.listening = el)}
                                                                        onChange={ei => {
                                                                            this.setState({ listening: ei })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <InputNumber
                                                                        className={style.inputNumber}
                                                                        value={this.state.reading}
                                                                        placeholder={'Reading'}
                                                                        type={'number'}
                                                                        ref={el => (this.reading = el)}
                                                                        onChange={ei => {
                                                                            this.setState({ reading: ei })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <InputNumber
                                                                        className={style.inputNumber}
                                                                        value={this.state.writing}
                                                                        placeholder={'Writing'}
                                                                        type={'number'}
                                                                        ref={el => (this.writing = el)}
                                                                        onChange={ei => {
                                                                            this.setState({ writing: ei })
                                                                        }}
                                                                    />
                                                                </Col>
                                                                <Col span={24}>
                                                                    <InputNumber
                                                                        className={style.inputNumber}
                                                                        value={this.state.speaking}
                                                                        placeholder={'Speaking'}
                                                                        type={'number'}
                                                                        ref={el => (this.speaking = el)}
                                                                        onChange={ei => {
                                                                            this.setState({ speaking: ei })
                                                                        }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col span={24}>
                                                                    {this.state.editIeltsIndex == 'false' ?
                                                                        <Button
                                                                            size={'small'}
                                                                            onClick={() => {
                                                                                if (this.state.examType) {
                                                                                    this.setState({
                                                                                        ieltsRequirements: [
                                                                                            ...this.state.ieltsRequirements,
                                                                                            ...[
                                                                                                {
                                                                                                    ExamType: this.state.examType,
                                                                                                    Overall: this.state.overall,
                                                                                                    Listening: this.state.listening,
                                                                                                    Reading: this.state.reading,
                                                                                                    Writing: this.state.writing,
                                                                                                    Speaking: this.state.speaking
                                                                                                }
                                                                                            ]
                                                                                        ],
                                                                                        examType: '', listening: '', overall: '', reading: '', speaking: '', writing: ''
                                                                                    })
                                                                                    this.overall.value = ''
                                                                                    this.listening.value = ''
                                                                                    this.reading.value = ''
                                                                                    this.writing.value = ''
                                                                                    this.speaking.value = ''
                                                                                }
                                                                            }}>
                                                                            Add
                                                                        </Button>
                                                                        :
                                                                        <Button
                                                                            size={'small'}
                                                                            onClick={() => { this.updateIeltsRequirement() }}>
                                                                            Update
                                                                        </Button>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col span={16}>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <Table
                                                                        bordered={true}
                                                                        pagination={{
                                                                            defaultPageSize: 2000,
                                                                            showSizeChanger: false,
                                                                            showQuickJumper: false
                                                                        }}
                                                                        columns={ieltsColumn}
                                                                        dataSource={this.state.ieltsRequirements}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row style={{ marginTop: 10 }}>
                                                                <Col span={8}>
                                                                    <h4>IELTS 5.5 (If acceptable in one module)</h4>
                                                                </Col>
                                                                <Col span={4}>
                                                                    <input
                                                                        type="radio"
                                                                        name="radioIeltsScoreAcceptable"
                                                                        value='true'
                                                                        onChange={this.changeIeltsScoreAcceptable}
                                                                        checked={this.state.ieltsScoreAcceptable}
                                                                    />
                                                                    Yes
                                                                    <input
                                                                        type="radio"
                                                                        name="radioIeltsScoreAcceptable"
                                                                        value='false'
                                                                        onChange={this.changeIeltsScoreAcceptable}
                                                                        checked={!this.state.ieltsScoreAcceptable}
                                                                    />
                                                                    No
                                                                </Col>
                                                            </Row>
                                                            <Row style={{ marginTop: 20 }}>
                                                                <Col span={8}>
                                                                    <h4>3 Years Bachelor Degree Acceptable</h4>
                                                                </Col>
                                                                <Col span={4}>
                                                                    <input
                                                                        type="radio"
                                                                        name="radioBachelorDegreeAcceptable"
                                                                        value='true'
                                                                        onChange={this.changeBachelorDegreeAcceptable}
                                                                        checked={this.state.bachelorDegreeAcceptable}
                                                                    />
                                                                    Yes
                                                                    <input
                                                                        type="radio"
                                                                        name="radioBachelorDegreeAcceptable"
                                                                        value='notAcceptable'
                                                                        onChange={this.changeBachelorDegreeAcceptable}
                                                                        checked={!this.state.bachelorDegreeAcceptable}
                                                                    />
                                                                    No
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                                { }
                                            </div>
                                        ) : null}
                                        {key == 5 ? (
                                            <div>
                                                <Card className={style.cardsep}>
                                                    <Quali
                                                        hide={true}
                                                        handleSubmit={data => {

                                                            let x = [...this.state.list, ...data]
                                                            this.setState({ list: x })
                                                        }}
                                                    />

                                                    <Table
                                                        size={'small'}
                                                        pagination={{
                                                            defaultPageSize: 10,
                                                            showSizeChanger: false,
                                                            showQuickJumper: false
                                                        }}
                                                        bordered={true}
                                                        columns={columns1}
                                                        dataSource={list}
                                                    />
                                                </Card>
                                            </div>
                                        ) : null}
                                        {key == 5 && universityId ? (
                                            <Card style={{ marginBottom: 10 }}>
                                                <div>
                                                    <Row>
                                                        <Col>
                                                            <div>
                                                                <GetAllFormFields inputSchema={editRequirements} apiurl={LAPI_URL} getFieldDecorator={getFieldDecorator} />
                                                            </div>
                                                            {/* <div>
                                                    <label>Show By Counsellors</label>
                                                    <Select
                                                      allowClear
                                                      style={{
                                                        width: 180,
                                                        marginRight: 16,
                                                      }}
                                                      showSearch={true}
                                                      className={style.width100Pr}
                                                      value={this.state.courseId}
                                                      placeholder="Select Option"
                                                      optionFilterProp="display"
                                                      onChange={(counsellorId) => {
                                                        this.setState(
                                                          {
                                                            courseId: courseId && courseId.toString(),
                                                          },
                                                          () => {
                                                            setTimeout(() => {
                                                              this.reload();
                                                            }, 500);
                                                          }
                                                        );
                                                      }}
                                                    >
                                                      {this.state.courses.map((val, idn) => {
                                                        return (
                                                          <Option key={idn} value={val.id}>
                                                            {val.display}
                                                          </Option>
                                                        );
                                                      })}
                                                    </Select>
                                                  </div> */}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Card>
                                        ) : null}
                                    </TabPane>
                                )
                            })}


                            <TabPane tab={'Documents'} key={this.state.inputTypes.length + 1}>

                                {universityId ? <MasterDocUtils type={'university'} _id={universityId} /> :
                                    <Card><h3>University must be saved before uploading a file</h3></Card>}
                            </TabPane>

                            <TabPane tab={'View Courses'} key={this.state.inputTypes.length + 2}>
                                {<Card><a
                                    target={"_blank"}
                                    href={`/master/all-course?courseUniversityId=${universityId
                                        }`}
                                >
                                    Click here to view courses
                                </a></Card>}
                            </TabPane>
                            {universityId ?
                                <TabPane tab={'Import/Export Courses'} key={this.state.inputTypes.length + 3}>
                                    {<Card>
                                        <div>

                                            <Button
                                                className={styles.btn}
                                                loading={this.state.exportLoading}
                                                onClick={() => { this.exportExcel() }}
                                                type="primary">Export
                                            </Button>

                                            <Upload
                                                loading={this.state.importLoading}
                                                action={`${LAPI_URL}/filesUploader`}
                                                onChange={this.handleChange}>
                                                <Button>
                                                    <Icon type="upload" /> Import
                                                </Button>
                                            </Upload>
                                        </div>
                                    </Card>}
                                </TabPane>
                                : null}

                            <TabPane tab={"Billing Details"} key={10}>
                                <Card>
                                    <div className={"applicantsItem"}>

                                        <Button type='primary' onClick={() => this.setState({ showApplicantModal: true })}>Click to add</Button>
                                        <Modal
                                            title="Add Invoice Recipient Details"
                                            visible={this.state.showApplicantModal}
                                            onCancel={() => this.setState({ showApplicantModal: false })}
                                            onOk={() => this.setState({ showApplicantModal: false })}
                                            footer={[<Button
                                                type="primary"
                                                onClick={() => this.handleReferenceSubmit()}
                                                style={{ marginBottom: 10 }}
                                                loading={this.props.loading}>
                                                SAVE
                                            </Button>]}
                                        >
                                            <Form>
                                                <GetAllFormFields apiurl={LAPI_URL} inputSchema={newComissionSchema} getFieldDecorator={getFieldDecorator} />
                                            </Form>
                                        </Modal>
                                    </div>
                                    <Row style={{ marginTop: 40 }}>
                                        <Col span={24}>
                                            <Table
                                                bordered={true}
                                                style={{ width: '100%' }}
                                                columns={applicantListColumns}
                                                dataSource={this.state.applicantsList}
                                                pagination={false}
                                                scroll={{ x: 'max-content' }}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </TabPane>


                            {/* <TabPane tab={'Incentive'} key={this.state.inputTypes.length + 4}>
                                {<Card>
                                    <Row style={{ marginBottom:10}}>
                                    <Col span={4} style={{ textAlign: 'right', paddingRight: 10, marginTop:5 }}>
                                            <h4>Institutional Incentive($) : </h4>
                                        </Col>
                                        <Col span={16} >
                                        <Input
                                            value={this.state.institutionalIncentive}
                                            placeholder={'Institutional Incentive($)'}
                                            style={{ width: "300px" }}
                                            onChange={ei => {
                                                this.setState({
                                                    institutionalIncentive: Number(ei.target.value)
                                                })
                                            }}
                                        />
                                        </Col>
                                    
                                    </Row>
                                    </Card>}
                            </TabPane> */}
                        </Tabs>
                    </Card>
                </Form>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddUniversity)
